import { render, staticRenderFns } from "./CardGatewayList.vue?vue&type=template&id=41a95c82&"
import script from "./CardGatewayList.vue?vue&type=script&lang=ts&"
export * from "./CardGatewayList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports